import { ApiBase } from "~/extensions/api";
import { Log } from "~/extensions/utils";
const log = Log.create("PersonalApi");
export class PersonalApi extends ApiBase {
    find(command) {
        return this.request(command);
    }
}
